/**
 * Returnerar true om obj är ett objekt.
 * 
 * @param {any} obj 
 * @returns {boolean}
 */
export function isObject(obj){
    return obj && typeof(obj) !== "string" && !Array.isArray(obj) && Object.keys(obj).length > 0;
}

export const isString = s => typeof(s) === "string" || s instanceof String;

/**
 * Returnerar true om any är en funktion
 * 
 * @param {any} any 
 * @returns {boolean} - 
 */
export function isFunction(any){
    return any && typeof (any) === "function";
}

/**
 * Kontrollerar om en sträng är tom, null eller undefined.
 * @param {string} string 
 * @returns {boolean}
 */
export function isNullUndefinedOrEmpty(string) {
    return string == null || string.toString().trim().length === 0;
}

/**
 * Evaluera den första funktionen och returnera dess värde ifall det inte är null eller undefined. Evaluera annars den andra funktionen och returera dess värde.
 * @param {function} primaryFunction 
 * @param {function} secondaryFunction 
 * @param {*} param 
 * @returns {*}
 */
export function fallback(primaryFunction, secondaryFunction, param = undefined) {
    const primaryValue = primaryFunction(param);
    if (primaryValue != null) {
        return primaryValue;
    }

    return secondaryFunction(param);
}

/**
 * Convterar ett object properties to camelCase
 * @param {string} o 
 * @param {function} primaryFunction 
 * @param {*} param 
 * @returns {*}
 */
export function toCamelCase(o) {
    var newO, origKey, newKey, value;
    if (o instanceof Array) {
        return o.map(function(value) {
            if (typeof value === "object") {
                value = toCamelCase(value);
            }
            return value;
        });
    } else {
        newO = {};
        for (origKey in o) {
            if (Object.prototype.hasOwnProperty.call(o, origKey)) {
                newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                value = o[origKey];
                if (value instanceof Array || (value !== null && value.constructor === Object)) {
                    value = toCamelCase(value);
                }
                newO[newKey] = value;
            }
        }
    }
    return newO;
}